import React from "react";
import {Builder} from "../../_theme/_partials";

export function BuilderPage() {
    return <Builder />;
}
